import React from 'react';
import { REQUIRE_CREDIT_NOTE } from '../../order-sale-form';
import { RhCheckbox } from '../../../../../../../dum';
import { useReceiptAppliesTax } from '../../helpers/use-receipt-applies-tax';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function RequireCreditNoteInput() {
    const appliesTax = useReceiptAppliesTax();
    return (
        <RhCheckbox
            name={REQUIRE_CREDIT_NOTE}
            label={shortLabel(FIELD_LABELS.require_credit_note)}
            disabled={!appliesTax}
        />
    );
}
